import React, { useRef } from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import ReactQuill, { Quill } from 'react-quill';
import { useSelector } from 'react-redux';
import { router } from '@forge/bridge';

import 'react-quill/dist/quill.snow.css';

import { RootState } from '../store/store';
import { Glance } from '../styled';

interface Props {
    field: ControllerRenderProps<FieldValues, 'content'>;
}

const Link = Quill.import('formats/link');

class CustomLink extends Link {
    static create(value: string) {
        const node = super.create(value);
        node.removeAttribute('target');
        node.removeAttribute('rel');
        node.setAttribute('class', 'custom-link');
        return node;
    }
}

Quill.register('formats/link', CustomLink);

const RichTextEditor: React.FC<Props> = ({ field }) => {
    const { canEdit } = useSelector((state: RootState) => state.incidentBanners);
    const quill = useRef();

    const previewLinks = window.document.getElementsByClassName('ql-preview');
    Array.from(previewLinks).forEach(linkElement =>
        linkElement.addEventListener('click', e => {
            router.open(linkElement.getAttribute('href') || '');
        })
    );

    return (
        <Glance>
            <ReactQuill
                ref={
                    //@ts-ignore
                    el => (quill.current = el)
                }
                theme='snow'
                placeholder='Type here...'
                onChange={field.onChange}
                value={field.value}
                readOnly={!canEdit}
            />
        </Glance>
    );
};

export default RichTextEditor;
